export default __webpack_public_path__ + "static/media/linebreaker.27e73f09.png";